export default function buildMediaQuery(_ref, not) {
  var minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth;

  var query = '';

  if (minWidth) {
    query += '(min-width: ' + minWidth + ')';
  }

  if (minWidth && maxWidth) {
    query += ' and ';
  }

  if (maxWidth) {
    query += '(max-width: ' + maxWidth + ')';
  }

  if (not) {
    query = 'not all and ' + query;
  }

  return query;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-viewport/es/buildMediaQuery.js
// module id = 543
// module chunks = 0